import { Injectable } from '@angular/core';

// @ts-ignore
@Injectable({
  providedIn: 'root'
})
export enum Environment {
  Prod = 'prod',
  Staging = 'staging',
  Local = '172.27.57.242',
}
export const deepLinkStaging = {
  hdi: 'https://hifptapp.page.link/naxz',
  fplay: 'https://staging-hi.fpt.vn/shopping/fpt/fplay/package',
  longchau: 'https://staging-hi.fpt.vn/direction/VdP1',
  uudai: 'https://staging-hi.fpt.vn/shopping/fvoucher/home',
  fconnect: 'https://staging-hi.fpt.vn/shopping/fconnect/service-it',


    };
export const deepLinkProduction = {
  hdi: 'https://hifptapp.page.link/naxz',
  fplay: 'https://hi.fpt.vn/shopping/fpt/fplay/package',
  longchau: 'https://staging-hi.fpt.vn/direction/VdP1',
  uudai: 'https://hi.fpt.vn/shopping/fvoucher/home',
  fconnect: 'https://hi.fpt.vn/shopping/fconnect/service-it',

};
export class EnvironmentsService {
  // tslint:disable-next-line:variable-name
  private _env!: Environment;
  // tslint:disable-next-line:variable-name
  private _apiUrl!: string;
  // tslint:disable-next-line:variable-name
 
  // tslint:disable-next-line:variable-name
  _deepLink: any;
  // tslint:disable-next-line:variable-name
  _domain: any;
  constructor() { }
  init(): Promise<void> {
    return new Promise(resolve => {
      this.setEnvVariables();
      resolve();
    });
  }
  get env(): Environment {
    return this._env;
  }
  private setEnvVariables(): void {
    const hostname = window && window.location && window.location.hostname;
    if (hostname === 'stag.layhen.vn' || hostname === '192.168.1.18' || hostname === 'localhost' || hostname === 'layhen.vn' || hostname === '192.168.1.42' || hostname === '172.27.57.242' || hostname ==='172.27.57.183') {
      this._env = Environment.Local;
      this._apiUrl = 'https://hifpt-api-stag.fpt.vn';
      this._domain = 'https://staging-hi.fpt.vn';
     
      this._deepLink = deepLinkStaging;
    } else if (hostname === 'staging-hi.fpt.vn') {
      this._env = Environment.Staging;
      this._apiUrl = 'https://hifpt-api-stag.fpt.vn';
    
      this._deepLink = deepLinkStaging;
      this._domain = 'https://staging-hi.fpt.vn';
    } else if (hostname === 'hi.fpt.vn') {
      this._env = Environment.Prod;
      this._apiUrl = 'https://hifpt-api.fpt.vn';
    
      this._deepLink = deepLinkProduction;
      this._domain = 'https://hi.fpt.vn';

    } else {
      console.warn(`Cannot find environment for host name ${hostname}`);
    }
  }

  get apiUrl(): string {
    return this._apiUrl;
  }
 
  get deepLink(): any {
    return this._deepLink;
  }
  get domain(): any {
    return this._domain;
  }
}
